import { createAsyncThunk as rtkCreateAsyncThunk } from '@reduxjs/toolkit';
import { AppState } from 'app/store/configureStore';
import axios from 'axios';
import { UploadImageResponse } from 'types/api.types';
import { UploadImageRequestData } from 'types/general.types';

export const createAsyncThunk = rtkCreateAsyncThunk.withTypes<{
  state: AppState;
}>();

export const uploadImageHandler = async (
  link: string,
  data: UploadImageRequestData
) => {
  const response = await axios.post<UploadImageResponse>(
    link,
    {
      fileName: data.image.fileName,
      cropOptions: data.image.cropOptions,
    },
    {
      cancelToken: data.cancelTokenSource?.token,
      withCredentials: true,
    }
  );

  const {
    _links: { upload, uploadStatus: uploadStatusLink },
  } = response.data.response.image.item;

  await axios.put(upload.href, data.image.file, {
    cancelToken: data.cancelTokenSource?.token,
    headers: { 'Content-Type': data.image.file.type },
  });

  return {
    uploadStatusLink,
  };
};
